import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#1a1a1a] text-white p-6 text-center">
          <div>
            <h1 className="text-3xl font-serif mb-4">Nešto nije u redu</h1>
            <p className="text-gray-400 mb-8 max-w-md mx-auto">
              Došlo je do neočekivane greške. Molimo vas da osvježite stranicu ili se vratite kasnije.
            </p>
            <button
              onClick={() => window.location.href = '/'}
              className="px-8 py-3 bg-[#c5a27d] text-white rounded-sm hover:bg-[#b08d66] transition-colors"
            >
              Nazad na početnu
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
